import clsx from 'clsx';
import DOMPurify from 'isomorphic-dompurify';
import Link from 'next/link';

import 'react-loading-skeleton/dist/skeleton.css';

import Card, { CardContent, CardMedia } from '@/components/@base/card';
import { Text } from '@/components/@base/typography';
import Props from '@/components/shared/components/search/result/item/type';

import useCommonModalStore from '@/store/common-modal-store';

export default function Item({ icon, title, slug, demoId, linkId, className }: Props) {
  const { setShow } = useCommonModalStore();
  const titleContent = DOMPurify.sanitize(title);

  const handleCloseModal = () => {
    setShow(false);
  };
  const link = demoId ? `/web/${slug}/demo?demo_id=${demoId}` : `/web/${slug}`;
  return (
    <Link href={link} onClick={handleCloseModal} prefetch={false}>
      <Card
        id={linkId}
        noShadow
        center
        className={clsx(
          className,
          'w-full flex-row items-center justify-start gap-3 rounded-none border-0! border-b! border-[#F4F5F6] py-2',
        )}
      >
        <CardContent className='active::text-[#FF9606] flex h-14 w-full items-center justify-start gap-3 rounded-lg! p-0 pr-2 text-[#5B5C60] transition-colors delay-200 hover:bg-[#FFF5E6] hover:text-[#FF9606] active:bg-[#FFF5E6]'>
          <CardMedia src={icon.publicLink} alt={icon.title} width={40} height={40} />

          <Text
            className='search-result text-sm text-[#5B5C60]'
            dangerouslySetInnerHTML={{ __html: titleContent }}
          />
        </CardContent>
      </Card>
    </Link>
  );
}
